import { useQueries } from "@tanstack/react-query";

import { getProgramContracts } from "services";

import { GET_PROGRAM_CONTRACTS_ADMIN } from "consts";

export const useGetCarbonProgramContractsForPrograms = (programIds: string[], { enabled }: { enabled: boolean } = { enabled: true }) =>
  useQueries({
    queries: programIds.map((programId) => ({
      queryKey: [GET_PROGRAM_CONTRACTS_ADMIN, programId],
      queryFn: () => getProgramContracts(programId),
      enabled: enabled && !!programId,
    })),
  });
